import * as Search from "./Search/index.js";
import * as Detail from "./Detail/index.js";
import * as Placard from "./Placard/index.js";
import * as ContactRoles from "./ContactRoles/index.js";
import * as PropertyTypes from "./PropertyTypes/index.js";
import * as CompanyLeaseComp from "./CompanyLeaseComp/index.js";
import * as LeaseComps from "./LeaseComps/index.js";
import * as PropertyContactRoles from "./PropertyContactRoles/index.js";
import * as GeoLookup from "./GeoLookup/index.js";
import * as IntegrationTest from "./IntegrationTest/index.js";
import * as ListingCount from "./ListingCount/index.js";
import * as SiteMap from "./SiteMap/index.js";
import * as ValidateEmail from "./ValidateEmail/index.js";
import { AreaMeasure } from "../../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.Brokers.ViewModels.AreaMeasure */
export { AreaMeasure };
/** CoStar.Api.Brokers.ViewModels.PropertyUnitType */
export var PropertyUnitType;
(function (PropertyUnitType) {
    PropertyUnitType[PropertyUnitType["None"] = 0] = "None";
    PropertyUnitType[PropertyUnitType["SquareFoot"] = 1] = "SquareFoot";
    PropertyUnitType[PropertyUnitType["Acre"] = 2] = "Acre";
    PropertyUnitType[PropertyUnitType["Rooms"] = 3] = "Rooms";
    PropertyUnitType[PropertyUnitType["Beds"] = 4] = "Beds";
})(PropertyUnitType || (PropertyUnitType = {}));
/** CoStar.Api.Brokers.ViewModels.PhoneType */
export var PhoneType;
(function (PhoneType) {
    PhoneType[PhoneType["Office"] = 1] = "Office";
    PhoneType[PhoneType["Mobile"] = 2] = "Mobile";
    PhoneType[PhoneType["Fax"] = 3] = "Fax";
    PhoneType[PhoneType["Home"] = 4] = "Home";
    PhoneType[PhoneType["Pager"] = 5] = "Pager";
    PhoneType[PhoneType["Marketing"] = 6] = "Marketing";
})(PhoneType || (PhoneType = {}));
/** CoStar.Api.Brokers.ViewModels.LengthMeasure */
export var LengthMeasure;
(function (LengthMeasure) {
    LengthMeasure[LengthMeasure["None"] = 0] = "None";
    LengthMeasure[LengthMeasure["Inch"] = 1] = "Inch";
    LengthMeasure[LengthMeasure["Foot"] = 2] = "Foot";
    LengthMeasure[LengthMeasure["Mile"] = 3] = "Mile";
    LengthMeasure[LengthMeasure["Meter"] = 4] = "Meter";
    LengthMeasure[LengthMeasure["Kilometer"] = 5] = "Kilometer";
})(LengthMeasure || (LengthMeasure = {}));
/** CoStar.Api.Brokers.ViewModels.BusinessType */
export var BusinessType;
(function (BusinessType) {
    BusinessType[BusinessType["None"] = 0] = "None";
    BusinessType[BusinessType["CorporateUserNonRetail"] = 1] = "CorporateUserNonRetail";
    BusinessType[BusinessType["ResidentialDevelopers"] = 2] = "ResidentialDevelopers";
    BusinessType[BusinessType["EducationUniversity"] = 3] = "EducationUniversity";
    BusinessType[BusinessType["Government"] = 4] = "Government";
    BusinessType[BusinessType["InstitutionalInvestor"] = 5] = "InstitutionalInvestor";
    BusinessType[BusinessType["Internal"] = 6] = "Internal";
    BusinessType[BusinessType["Owner"] = 7] = "Owner";
    BusinessType[BusinessType["Lender"] = 8] = "Lender";
    BusinessType[BusinessType["PropertyManagement"] = 9] = "PropertyManagement";
    BusinessType[BusinessType["PublicRelations"] = 10] = "PublicRelations";
    BusinessType[BusinessType["TaxAppeal"] = 11] = "TaxAppeal";
    BusinessType[BusinessType["TradeGroupsNonProfitAssociations"] = 12] = "TradeGroupsNonProfitAssociations";
    BusinessType[BusinessType["BuildingServicesVendors"] = 13] = "BuildingServicesVendors";
    BusinessType[BusinessType["AppraisalValuation"] = 14] = "AppraisalValuation";
    BusinessType[BusinessType["BrokerageCommercial"] = 15] = "BrokerageCommercial";
    BusinessType[BusinessType["Associations"] = 16] = "Associations";
    BusinessType[BusinessType["Telecommunications"] = 17] = "Telecommunications";
    BusinessType[BusinessType["Architect"] = 18] = "Architect";
    BusinessType[BusinessType["Consultants"] = 19] = "Consultants";
    BusinessType[BusinessType["MortgageBrokersFinance"] = 20] = "MortgageBrokersFinance";
    BusinessType[BusinessType["Media"] = 21] = "Media";
    BusinessType[BusinessType["Retailer"] = 22] = "Retailer";
    BusinessType[BusinessType["BrokerageResidential"] = 23] = "BrokerageResidential";
    BusinessType[BusinessType["BrokerageResimercial"] = 24] = "BrokerageResimercial";
    BusinessType[BusinessType["ConstructionCompanies"] = 25] = "ConstructionCompanies";
    BusinessType[BusinessType["ExecutiveSuites"] = 26] = "ExecutiveSuites";
    BusinessType[BusinessType["Hotels"] = 27] = "Hotels";
    BusinessType[BusinessType["ProfessionalServices"] = 28] = "ProfessionalServices";
    BusinessType[BusinessType["Utilities"] = 29] = "Utilities";
    BusinessType[BusinessType["TitleCompany"] = 30] = "TitleCompany";
})(BusinessType || (BusinessType = {}));
import { MatchType } from "../../../../CoStar/Api/AptsSearch/ViewModels/index.js";
/** CoStar.Api.Brokers.ViewModels.MatchType */
export { MatchType };
/** CoStar.Api.Brokers.ViewModels.OrgType */
export var OrgType;
(function (OrgType) {
    OrgType[OrgType["None"] = 0] = "None";
    OrgType[OrgType["CorpLlc"] = 1] = "CorpLlc";
    OrgType[OrgType["PartnershipLlp"] = 2] = "PartnershipLlp";
    OrgType[OrgType["Nonprofit"] = 3] = "Nonprofit";
    OrgType[OrgType["SoleProp"] = 4] = "SoleProp";
    OrgType[OrgType["Government"] = 5] = "Government";
    OrgType[OrgType["Association"] = 6] = "Association";
})(OrgType || (OrgType = {}));
import { AreaType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.Brokers.ViewModels.AreaType */
export { AreaType };
/** CoStar.Api.Brokers.ViewModels.IndustryType */
export var IndustryType;
(function (IndustryType) {
    IndustryType[IndustryType["None"] = 0] = "None";
    IndustryType[IndustryType["TransportationAndWarehousing"] = 2] = "TransportationAndWarehousing";
    IndustryType[IndustryType["RealEstate"] = 4] = "RealEstate";
    IndustryType[IndustryType["Manufacturing"] = 5] = "Manufacturing";
    IndustryType[IndustryType["Retailer"] = 6] = "Retailer";
    IndustryType[IndustryType["FinanceAndInsurance"] = 7] = "FinanceAndInsurance";
    IndustryType[IndustryType["PublicAdministration"] = 9] = "PublicAdministration";
    IndustryType[IndustryType["Construction"] = 10] = "Construction";
    IndustryType[IndustryType["Information"] = 11] = "Information";
    IndustryType[IndustryType["ProfessionalScientificAndTechnicalServices"] = 12] = "ProfessionalScientificAndTechnicalServices";
    IndustryType[IndustryType["Services"] = 13] = "Services";
    IndustryType[IndustryType["HealthCareAndSocialAssistance"] = 15] = "HealthCareAndSocialAssistance";
    IndustryType[IndustryType["AccommodationAndFoodServices"] = 17] = "AccommodationAndFoodServices";
    IndustryType[IndustryType["AdministrativeAndSupportAndWasteManagement"] = 18] = "AdministrativeAndSupportAndWasteManagement";
    IndustryType[IndustryType["AgricultureForestryFishingAndHunting"] = 19] = "AgricultureForestryFishingAndHunting";
    IndustryType[IndustryType["ArtsEntertainmentAndRecreation"] = 20] = "ArtsEntertainmentAndRecreation";
    IndustryType[IndustryType["EducationalServices"] = 21] = "EducationalServices";
    IndustryType[IndustryType["ManagementOfCompaniesAndEnterprises"] = 22] = "ManagementOfCompaniesAndEnterprises";
    IndustryType[IndustryType["MiningQuarryingAndOilAndGasExtraction"] = 23] = "MiningQuarryingAndOilAndGasExtraction";
    IndustryType[IndustryType["RentalAndLeasingServices"] = 24] = "RentalAndLeasingServices";
    IndustryType[IndustryType["Utilities"] = 25] = "Utilities";
    IndustryType[IndustryType["WasteManagementAndRemediationServices"] = 26] = "WasteManagementAndRemediationServices";
    IndustryType[IndustryType["Wholesaler"] = 27] = "Wholesaler";
})(IndustryType || (IndustryType = {}));
/** CoStar.Api.Brokers.ViewModels.OwnerType */
export var OwnerType;
(function (OwnerType) {
    OwnerType[OwnerType["None"] = 0] = "None";
    OwnerType[OwnerType["CorporateUser"] = 1] = "CorporateUser";
    OwnerType[OwnerType["PublicREIT"] = 2] = "PublicREIT";
    OwnerType[OwnerType["Individual"] = 3] = "Individual";
    OwnerType[OwnerType["Government"] = 4] = "Government";
    OwnerType[OwnerType["BankFinance"] = 5] = "BankFinance";
    OwnerType[OwnerType["DeveloperOwnerNTL"] = 6] = "DeveloperOwnerNTL";
    OwnerType[OwnerType["PensionFund"] = 7] = "PensionFund";
    OwnerType[OwnerType["Insurance"] = 8] = "Insurance";
    OwnerType[OwnerType["NonProfit"] = 9] = "NonProfit";
    OwnerType[OwnerType["Endowment"] = 10] = "Endowment";
    OwnerType[OwnerType["InvestmentManager"] = 11] = "InvestmentManager";
    OwnerType[OwnerType["OtherUnknownInstl"] = 12] = "OtherUnknownInstl";
    OwnerType[OwnerType["SovereignWealthFnd"] = 13] = "SovereignWealthFnd";
    OwnerType[OwnerType["REOC"] = 14] = "REOC";
    OwnerType[OwnerType["ListedFunds"] = 15] = "ListedFunds";
    OwnerType[OwnerType["DeveloperOwnerRGNL"] = 16] = "DeveloperOwnerRGNL";
    OwnerType[OwnerType["Trust"] = 17] = "Trust";
    OwnerType[OwnerType["TenantsInCommon"] = 18] = "TenantsInCommon";
    OwnerType[OwnerType["PrivateREIT"] = 19] = "PrivateREIT";
    OwnerType[OwnerType["OtherPrivate"] = 20] = "OtherPrivate";
    OwnerType[OwnerType["EquityFunds"] = 21] = "EquityFunds";
    OwnerType[OwnerType["Educational"] = 22] = "Educational";
    OwnerType[OwnerType["Religious"] = 24] = "Religious";
    OwnerType[OwnerType["Medical"] = 25] = "Medical";
    OwnerType[OwnerType["SpecialServicer"] = 26] = "SpecialServicer";
})(OwnerType || (OwnerType = {}));
/** CoStar.Api.Brokers.ViewModels.GrowthType */
export var GrowthType;
(function (GrowthType) {
    GrowthType[GrowthType["None"] = 0] = "None";
    GrowthType[GrowthType["Stable"] = 1] = "Stable";
    GrowthType[GrowthType["Growing"] = 2] = "Growing";
    GrowthType[GrowthType["GrowingRapidly"] = 3] = "GrowingRapidly";
    GrowthType[GrowthType["Downsizing"] = 4] = "Downsizing";
    GrowthType[GrowthType["Bankrupt"] = 5] = "Bankrupt";
})(GrowthType || (GrowthType = {}));
/** CoStar.Api.Brokers.ViewModels.StockExchange */
export var StockExchange;
(function (StockExchange) {
    StockExchange[StockExchange["None"] = 0] = "None";
    StockExchange[StockExchange["NewYorkStockExchange"] = 1] = "NewYorkStockExchange";
    StockExchange[StockExchange["NASDAQ"] = 2] = "NASDAQ";
    StockExchange[StockExchange["NewYorkStockExchangeA"] = 3] = "NewYorkStockExchangeA";
    StockExchange[StockExchange["OverTheCounterX"] = 4] = "OverTheCounterX";
    StockExchange[StockExchange["OverTheCounterB"] = 5] = "OverTheCounterB";
    StockExchange[StockExchange["OverTheCounterPinkSheets"] = 6] = "OverTheCounterPinkSheets";
    StockExchange[StockExchange["OverTheCounterBulletinBoard"] = 7] = "OverTheCounterBulletinBoard";
    StockExchange[StockExchange["TorontoStockExchange"] = 8] = "TorontoStockExchange";
    StockExchange[StockExchange["TSXVentureExchange"] = 9] = "TSXVentureExchange";
    StockExchange[StockExchange["LondonStockExchange"] = 10] = "LondonStockExchange";
    StockExchange[StockExchange["DeutscheB\u00F6rseGroup"] = 11] = "DeutscheB\u00F6rseGroup";
    StockExchange[StockExchange["PAR"] = 12] = "PAR";
    StockExchange[StockExchange["AMS"] = 13] = "AMS";
    StockExchange[StockExchange["BRU"] = 14] = "BRU";
    StockExchange[StockExchange["LIS"] = 15] = "LIS";
    StockExchange[StockExchange["OSL"] = 16] = "OSL";
    StockExchange[StockExchange["DBX"] = 17] = "DBX";
    StockExchange[StockExchange["HongKongExchanges"] = 18] = "HongKongExchanges";
    StockExchange[StockExchange["TokyoStockExchange"] = 19] = "TokyoStockExchange";
    StockExchange[StockExchange["SHAN"] = 20] = "SHAN";
    StockExchange[StockExchange["ShenzhenStockExchange"] = 21] = "ShenzhenStockExchange";
    StockExchange[StockExchange["KSX"] = 22] = "KSX";
    StockExchange[StockExchange["ASX"] = 23] = "ASX";
})(StockExchange || (StockExchange = {}));
export { Search, Detail, Placard, ContactRoles, PropertyTypes, CompanyLeaseComp, LeaseComps, PropertyContactRoles, GeoLookup, IntegrationTest, ListingCount, SiteMap, ValidateEmail };
